import { AutogenModelPbwLoadboardServices, AutogenRowPbwLoadboardServices } from "./autogen/AutogenModelPbwLoadboardServices";

export class ModelPbwLoadboardServices extends AutogenModelPbwLoadboardServices<RowPbwLoadboardServices> {
    constructor() {
        super(RowPbwLoadboardServices);
    }
}

export class RowPbwLoadboardServices extends AutogenRowPbwLoadboardServices {
}